import { Expose, Type } from 'class-transformer';
import { RECEIVE_TIME_SC } from 'src/app/common/const';
import { Device } from '../device';
import { GPSFrame } from '../gps-frame';
import { Vehicle } from '../vehicle';
import { Default } from 'src/app/shared/util/data-util';

export class AdditionalInfoImpl {

  @Expose()
  error: boolean;

  @Expose({ name: 'device' })
  @Type(() => Device)
  device: Device;

  @Expose({ name: 'vehicle' })
  @Type(() => Vehicle)
  vehicle: Vehicle;

  @Expose({ name: RECEIVE_TIME_SC })
  @Type(() => Date)
  receiveTime: Date;

  @Expose({ name: 'gps_frame' })
  @Type(() => GPSFrame)
  gpsFrame: GPSFrame;

  @Expose()
  @Default(false)
  hasLocation?: boolean;
}
